import type { ResolvedThemeValues } from "@shared-core/data/customer-api-types";
import { readableTextOn } from "@shared-core/domain/portal-theme";

/**
 * The design-token variables a resolved theme sets on the portal. Only these names ever reach the page: a theme
 * carries no CSS of its own (brief §6). Text on each coloured surface is the readable one for that colour, so a pale
 * or dark main colour never leaves a button unreadable.
 */
export function portalThemeCssVariables(
  values: ResolvedThemeValues,
): Record<string, string> {
  return {
    "--primary": values.main_colour,
    "--primary-foreground": readableTextOn(values.main_colour),
    "--ring": values.main_colour,
    "--secondary": values.secondary_colour,
    "--secondary-foreground": readableTextOn(values.secondary_colour),
    "--background": values.background_colour,
    "--foreground": values.text_colour,
    "--card-foreground": values.text_colour,
    "--accent": values.highlight_colour,
    "--accent-foreground": readableTextOn(values.highlight_colour),
    "--success": values.success_colour,
    "--success-foreground": readableTextOn(values.success_colour),
    "--warning": values.warning_colour,
    "--warning-foreground": readableTextOn(values.warning_colour),
    "--portal-banner-text": values.banner_text_colour,
  };
}
